<template>
  <AppBody
    title="Produtores / Regras de Pagamento"
    :subtitle="pageSubtitle"
    :actions="actions"
  >
    <v-data-table
      class="table-body"
      no-data-text="Nenhum registro encontrado"
      loading-text="Buscando informações..."
      :headers="headersFormaPgto"
      :items="$lojas_formas_pgto.formas_pagamento"
      :items-per-page="10"
      sort-by="descricao"
      :loading="$lojas_formas_pgto.formas_pgto_loading"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: 'Regras de pagamento por página:',
      }"
    >
      <template v-slot:item.actions="{ item }" class="table-actions">
        <div style="display: flex; justify-content: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                icon
                @click="editFormPayment(item)"
                dark
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Regras</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="30"
                v-bind="attrs"
                v-on="on"
                width="30"
                small
                icon
                @click="openRegras(item)"
                dark
              >
                <v-icon>mdi-cog-outline</v-icon>
              </v-btn>
            </template>
            <span>Regras</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <ModalFormasDePagamento />
    <ModalRulesList />
  </AppBody>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PaymentMethods",
  metaInfo: {
    title: "Formas de pagamento | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Formas de pagamento | ElevenTickets",
      },
    ],
  },
  props: {},
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    ModalFormasDePagamento: () =>
      import("@/components/lojas/FormasDePagamento/ModalFormasDePagamento.vue"),
    ModalRulesList: () =>
      import("@/components/lojas/FormasDePagamento/ModalRulesList.vue"),
  },
  data() {
    return {
      loja: "",
      modalSelectLoja: false,
      actions: [
        {
          name: "Cadastrar",
          action: () => this.registerFormaPgto(),
        },
      ],
      headersFormaPgto: [
        {
          text: "ID",
          align: "center",
          sortable: false,
          value: "idforma_pag",
        },
        {
          text: "Descrição",
          align: "center",
          sortable: false,
          value: "dscforma_pag",
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  watch: {
    "$store.getters.storeSequencial": function () {
      this.$lojas_formas_pgto.getFormasPgto(this.storeInfo.idloja);
    },
  },
  computed: {
    ...mapGetters(["storeSequencial", "storeInfo"]),
    pageSubtitle() {
      if (this.$lojas_formas_pgto.loja_nome)
        return "Regras de Pagamento - " + this.$lojas_formas_pgto.loja_nome;
      return "Regras de Pagamento";
    },
  },
  methods: {
    registerFormaPgto() {
      this.$lojas_formas_pgto.addFormasPgto = true;
      this.$lojas_formas_pgto.actionType = "new";
    },
    editFormPayment(item) {
      const {
        idloja,
        idforma_pag,
        ordem,
        dscforma_pag,
        dscinterna,
        tipo,
        texto_apoio,
        ativo,
      } = item;
      this.$lojas_formas_pgto.addFormasPgto = true;
      this.$lojas_formas_pgto.actionType = "edit";
      this.$lojas_formas_pgto.paymentForm.idLoja = idloja;
      this.$lojas_formas_pgto.paymentForm.idformaPag = idforma_pag;
      this.$lojas_formas_pgto.paymentForm.order = ordem;
      this.$lojas_formas_pgto.paymentForm.description = dscforma_pag;
      this.$lojas_formas_pgto.paymentForm.internalDescription = dscinterna;
      this.$lojas_formas_pgto.paymentForm.paymentFormType = tipo;
      this.$lojas_formas_pgto.paymentForm.supportText = texto_apoio;
      this.$lojas_formas_pgto.paymentForm.active = ativo;
    },
    openRegras(item) {
      const { idloja, idforma_pag } = item;
      this.$lojas_formas_pgto.modalRulesListOpen = true;
      this.$lojas_formas_pgto.getRegrasPgto(idloja, idforma_pag);
      this.$lojas_formas_pgto.getAdquirentes(idloja);
      this.$lojas_formas_pgto.getAnaliseDeRisco(idloja);
      this.$lojas_formas_pgto.ruleForm.idformaPag = idforma_pag;
    },
  },
  created() {
    const lojaNome = this.$axios.getLocal("loja_formas_pagamento_nome")?.data;
    if (lojaNome) {
      this.$lojas_formas_pgto.loja_nome = lojaNome;
    }
  },
  mounted() {
    if (this.$axios.getLocal("loja_formas_pagamento_nome")?.data) {
      let nomeLoja = this.$axios.getLocal("loja_formas_pagamento_nome").data;
      this.$loja_consumidor.loja_nome = nomeLoja;
    }
  },
  beforeMount() {
    if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "loja")
      return this.$lojas_formas_pgto.getFormasPgto(this.storeInfo.idloja);
    else {
      if (this.storeInfo.idloja) {
        this.$lojas_formas_pgto.getFormasPgto(this.storeInfo.idloja);
        return;
      }
    }
  },
};
</script>
<style scoped>
.produtos-gerenciar-button2 {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  position: relative;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}
</style>
